export const environment = {
    production: true,
    hmr       : false,
    //VARIABLES DE CONEXIONES
    url: 'https://culturalgo.com/api',
    urlLogos: 'https://culturalgo.com',
    urlConteos: 'https://app04.culturalgo.com/plataform/#/counting/',
    urlWcpExterno: 'https://app04.culturalgo.com/plataform/#/wcp/',
    urlConteosGcti: 'https://gcti.culturalgo.com/plataform/#/counting/',
    urlConteosInnmotion: 'https://innmotion.app/#/counting/',
    urlSurveyAutologin: 'https://app01.culturalgo.com/nom35a/#/home',
    urlTableau: 'https://graphics04.culturalgo.com:8443/CGoReporting--VERSION--/index.jsp',
    urlTableauCovid: 'https://graphics04.culturalgo.com:8443/CGoReportingCoV/index.jsp',
    urlAssets: 'https://culturalgo.com/assetsCGO5/',
    urlAssetsFileServer: 'https://fileserver.culturalgo.com/ReadFile?path=cgo/',
    // urlBD: "mongodb://userPlataforma-rw:pass3217320@10.128.0.7:27017/admin",
    urlEncuestador: 'http://app01.culturalgo.com/encuestador/#/login?pod=',
    urlFileManager: '/surveyadministrator/backend/',
    urlAnalisisExcel: 'https://analyzerexcel.culturalgo.com:8443',
    urlSengridWebHook:'https://emaillog.culturalgo.com:8443',
    url4allExterno:'https://app04.culturalgo.com/plataform/#/results/4all/',
};
